module.exports = __webpack_public_path__ + "img/AZ.e9dc94be.svg";